import React, { Component } from 'react';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: 75rem;
  margin: auto;
  // position: relative;
`;
